'use client';

export function DateInput({
  label,
  value,
  onChange,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-xs font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 block w-full rounded-md border-gray-300 text-xs shadow-sm
                   focus:border-primary focus:ring focus:ring-primary-300"
      />
    </div>
  );
}